import router from '@/router';

const OCRoutes = [
  {
    path: 'telephone_numbers',
    name: 'UserTelephoneNumbers',
    component: {
      name: 'AdminTelephoneNumbers',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'telephone_number',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminTelephoneNumbersIndex',
        component: () => import('../views/TelephoneNumbers.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));